import $ from '../../../../../FrontendBundle/Resources/js/jquery';
import SetOptionCommand from '../command/setOptionCommand';
import DropdownField from './dropdownField';

/**
 * @class CoverField
 */
export default class CoverField extends DropdownField {
    type = 'cover';
    supports = 'supportsCover';

    /**
     * Register click event on dropdown.
     *
     * @param {jQuery} dropdown
     */
    registerEventsForDropdown(dropdown) {
        dropdown.on('click', 'li a', (...args) => this.onChangeCover(...args));
    }

    onChangeCover(event) {
        const target = $(event.target);
        const item = this.currentItem;
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();

        const command = new SetOptionCommand(
            this.type,
            item,
            item.get('cover'),
            target.data('item'),
        );

        history.addAndExecuteCommand(command);

        event.preventDefault();
    }

    /**
     * Update options with item value.
     *
     * @param {ItemInterface} item
     */
    updateOptions(item) {
        const current = item.get('cover');
        const width = item.get('width');
        const options = [];
        let { coverOptions } = item;

        // remove square options for small drill
        if (width !== 80) coverOptions = coverOptions.filter(option => option !== 'square');

        coverOptions.forEach((option) => {
            const key = `cover_${option}`;

            options.push({
                key: option,
                value: this.translations[key]({ value: width }),
                active: option === current,
            });
        });

        this.setOptions(options);
    }

    /**
     * Check if item supports options dropdowns.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        const supportFlag = this.supports;

        return selectionLength === 1 && item && supportFlag && item[supportFlag] && item.supportsCover;
    }
}
